import authService from 'ApiService/Auth/AuthService';
import userService from 'ApiService/Student/userService';
import teacherOtherService from 'ApiService/Teacher/Other';
import Card from 'components/card';
import InputField from 'components/fields/InputField';
import { AuthContext } from 'contexts/AuthContext';
import Centered from 'layouts/auth/types/Centered';
import Redirect from 'pages/AuthProtection/Redirect';
import { useContext, useState } from 'react';
import toast from 'react-hot-toast';
import { RiEyeCloseLine, RiEyeLine } from 'react-icons/ri';
import { useNavigate } from 'react-router-dom';

function StudentUpdatePassword() {
  const router = useNavigate();
  const { state } = useContext(AuthContext);
  const [formData, setFormData] = useState({
    oldPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  const [showPasswords, setShowPasswords] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  if (!state?.user?.userId) {
    router('/auth/sign-in');
    return null;
  }

  const handleChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const togglePasswordVisibility = (field) => {
    setShowPasswords((prev) => ({ ...prev, [field]: !prev[field] }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (
      !formData.oldPassword ||
      !formData.newPassword ||
      !formData.confirmPassword
    ) {
      return toast.error('All fields are mandatory.');
    }
    if (formData.newPassword !== formData.confirmPassword) {
      return toast.error('New password and confirm password do not match.');
    }
    try {
      const response = await userService.updatePassword(
        formData.oldPassword,
        formData.newPassword,
        state?.user?.userId
      );

      if (response.data.success) {
        toast.success(response.data.message);
        setFormData({
          oldPassword: '',
          newPassword: '',
          confirmPassword: '',
        });
        router('/student');
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error(error.response.data.message);
    }
  };

  return (
    <Centered
      bgImage="linear-gradient(135deg, #868CFF 0%, #4318FF 100%)"
      maincard={
        <Card extra="max-w-[405px] md:max-w-[510px] md:w-[510px] h-max mx-2.5 md:mx-auto mt-[50px] mb-auto py-2.5 px-4 md:!p-[50px] pt-8 md:pt-[50px]">
          <form onSubmit={handleSubmit}>
            <h3 className="mb-[10px] text-4xl font-bold text-gray-900 dark:text-white">
              Update Password
            </h3>
            <p className="mb-9 ml-1 text-base text-gray-600">
              Please enter and confirm your new password.
            </p>
            <div className="relative">
              <InputField
                maxLength={25}
                minLength={8}
                label="Old Password"
                placeholder="Your Old Password"
                name="oldPassword"
                value={formData.oldPassword}
                onChange={handleChange}
                type={showPasswords.oldPassword ? 'text' : 'password'}
              />
              <button
                type="button"
                className="absolute  right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
                onClick={() => togglePasswordVisibility('oldPassword')}
              >
                {showPasswords.oldPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
              </button>
            </div>
            <div className="relative">
              <InputField
                maxLength={15}
                minLength={8}
                label="New Password"
                placeholder="Your New Password"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleChange}
                type={showPasswords.newPassword ? 'text' : 'password'}
              />
              <button
                type="button"
                className="absolute  right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
                onClick={() => togglePasswordVisibility('newPassword')}
              >
                {showPasswords.newPassword ? <RiEyeLine /> : <RiEyeCloseLine />}
              </button>
            </div>
            <div className="relative">
              <InputField
                maxLength={15}
                minLength={8}
                label="Confirm New Password"
                placeholder="Confirm New Password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                type={showPasswords.confirmPassword ? 'text' : 'password'}
              />
              <button
                type="button"
                className="absolute right-4 top-2/3 -translate-y-1/2 transform text-lg text-navy-700 dark:text-white"
                onClick={() => togglePasswordVisibility('confirmPassword')}
              >
                {showPasswords.confirmPassword ? (
                  <RiEyeLine />
                ) : (
                  <RiEyeCloseLine />
                )}
              </button>
            </div>
            <button
              type="submit"
              className="mt-4 w-full rounded-xl bg-brand-500 py-3 text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200"
            >
              Update Password
            </button>
          </form>
        </Card>
      }
    />
  );
}

export default StudentUpdatePassword;
